import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { Trans } from '@/constants'
import { getLocalLocale } from '@/common/locales'
import en from '@/lang/en.json'
import fa from '@/lang/fa.json'
import faEditor from '@/lang/editor-fa.json'


import { messages as faValidates } from '@/lang/form-validate-fa.json'
import { messages as enValidates } from '@/lang/form-validate-en.json'


const faMessages = Object.assign(fa, {
  validation: faValidates
}, faEditor)


const enMessages = Object.assign(en, {
  validation: enValidates
})

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: getLocalLocale(), // set locale
  fallbackLocale: Trans.FALLBACK_LANGUAGE,
  messages: {
    fa: faMessages,
    en: enMessages,
  }
})